var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block d-md-inline"},[_c('a',{staticClass:"btn btn-xs btn-link btn-icon bigger-130 text-danger",attrs:{"title":"Eliminar"},on:{"click":_vm.mtd_emitActionRemove}},[_c('feather',{attrs:{"type":"trash"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }